import React from 'react';
import { Row, Col } from 'antd';
import { Link } from "react-router-dom";
import cookie from 'react-cookies';

const topbar2_body={
    width: "80%",
	height: "45px",
    minWidth: "1000px",
	left:"10%",
	position:"absolute",
	zIndex:"990",
	transition:"0.5s",
	backgroundColor:"white",
	lineHeight:" 45px",
	textAlign:" center",
}
const topbar_sides ={
    width:"40%"
}
const topbar_mid={
    width:"20%",
    height:"60px",
    lineHeight:"60px",
    fontSize:"27px",
    color:"white",
	backgroundColor:"rgb(94,165,59)",
}

const topbar2_item={
	color:"rgb(94,135,59)",
}

function loginout (){
    cookie.remove('jwt_v2' ,{ path:"/",domain:".moxidata.cn" });
    cookie.remove('UserUid_v2' ,{ path:"/",domain:".moxidata.cn"});
    cookie.remove('modelid_v2' ,{ path:"/",domain:".moxidata.cn"});
    cookie.remove('phoneNumber_v2' ,{ path:"/",domain:".moxidata.cn"});

    cookie.remove('jwt_v2' ,{ path:"/" });
    cookie.remove('UserUid_v2' ,{ path:"/"});
    cookie.remove('modelid_v2' ,{ path:"/"});
    cookie.remove('phoneNumber_v2' ,{ path:"/"});
    window.location.reload() 
}


// 组件：顶部信息条
function Topbar2(props) {
    document.title =props.pagetitle

    let loggedIn =false;
    if(cookie.load("jwt_v2")!=undefined){
        loggedIn = true;
        var username = cookie.load("phoneNumber_v2")
    }
    return(
        <div>  
            <Row style={topbar2_body} justify='space-between'>
                <Row style={topbar_sides}>
                    <Link to="/forest/"  className='tabbar-item tabbar-item-left' style={topbar2_item}>{"<<"}返回首页</Link>
                    <Link to="/forest/" className='tabbar-item tabbar-item-left' style={topbar2_item}>文旅森林</Link>
                    <a href="https://app.moxidata.cn/moximerchants/moxiindex/" className='tabbar-item tabbar-item-left' style={topbar2_item}>魔席招商</a>
                    <a href='https://app.moxidata.cn/college/' className='tabbar-item tabbar-item-left' style={topbar2_item}>文旅学院</a>
                </Row>
                <Row style={topbar_mid} justify='center'>
                    {props.pagetitle}
                </Row>
                
                    {
                        !loggedIn && <Row  style={topbar_sides} justify='end'>
                            <Link className='tabbar-item tabbar-item-right' to="/forest/login" style={topbar2_item}>登录</Link>
                            <Link className='tabbar-item tabbar-item-right' to="/forest/login" style={topbar2_item}>注册</Link>
                        </Row>
                    }
                    {
                        loggedIn && <Row  style={topbar_sides} justify='end'>
                            <a href='https://app.moxidata.cn/userbackstage/' className='tabbar-item tabbar-item-right' style={topbar2_item}>{username}</a>
                            {/*<Link className="tabbar-item tabbar-item-right"  to="/forest/userbs" style={topbar2_item}>{username}</Link>*/}
                            <Col className="tabbar-item tabbar-item-right" onClick={loginout} style={topbar2_item}>退出登录</Col>
                        </Row>
                    }
            </Row>
        </div>
    )
}

export default Topbar2